import { motion } from "framer-motion";

export default function ProgressBar({ progress }) {
  return (
    <div
      data-testid="progress-bar"
      className="fixed top-0 left-0 w-full h-1.5 z-50"
      style={{ backgroundColor: "#18181B" }}
    >
      <motion.div
        className="h-full"
        style={{
          backgroundColor: "#FF007F",
          boxShadow: "0 0 10px rgba(255,0,127,0.8)",
          width: `${progress}%`,
        }}
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      />
    </div>
  );
}
